import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.2",
      d: "M7.555 8.646 15.427.76a.564.564 0 0 1 .79 0v.001l1.628 1.627v.001a.56.56 0 0 1 .163.394.57.57 0 0 1-.162.393L7.525 13.497l-.002.002a.564.564 0 0 1-.789 0L.761 7.525a.564.564 0 0 1 0-.79l1.63-1.63a.564.564 0 0 1 .788 0l3.526 3.54.425.426z"
    }, null, -1)
  ]))]))
}
export default { render: render }